import { useQueryClient } from '@tanstack/react-query';
import { useApiMutation } from '@/hooks/useApiMutation';
import { apiDelete, operationsClient } from '@/lib/api/client';
import { serviceAreaEndpoints } from '@/lib/api/endpoints';
import { serviceAreaKeys } from '@/lib/queryKeys';

interface DeleteServiceAreaInput {
  id: string;
}

/**
 * Removes a coverage area. One store, one call — the old two-call fan-out
 * (and its "Service area partially deleted" failure mode) died with the
 * coverage consolidation. Technician and business-unit assignments for the
 * ZIP cascade away server-side.
 */
export function useDeleteServiceArea() {
  const queryClient = useQueryClient();

  return useApiMutation<void, DeleteServiceAreaInput>({
    mutationFn: async ({ id }) => {
      if (!id) throw new Error('Cannot delete service area. Missing service area ID.');
      await apiDelete(operationsClient, serviceAreaEndpoints.delete(id));
    },
    onSettled: () => {
      queryClient.invalidateQueries({ queryKey: serviceAreaKeys.all() });
    },
  });
}
